<template>
  <component :is="forms[step]" :csrf="csrf" :phone="phone" :uid="uid" :until="until" @go-step="goStep($event)" />
</template>

<script>
import profilePasswordRemindSmsPhone from './profile-password-remind-sms-phone.vue';
import profilePasswordRemindSmsCode from './profile-password-remind-sms-code.vue';
import profilePasswordRemindSmsSuccess from './profile-password-remind-sms-success.vue';

export default {
  data: function () {
    return {
      forms: {
        step1: 'profilePasswordRemindSmsPhone',
        step2: 'profilePasswordRemindSmsCode',
        step3: 'profilePasswordRemindSmsSuccess',
      },
      //
      step: 'step1',
      phone: '',
      until: '',
      uid: 0,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
  },
  components: {
    profilePasswordRemindSmsPhone,
    profilePasswordRemindSmsCode,
    profilePasswordRemindSmsSuccess,
  },
  methods: {
    goStep(event) {
      switch (event.step) {
        // ввести телефон
        case 'step1':
          //
          break;
        // ввести код
        case 'step2':
          this.phone = event.phone;
          break;
        // успешный ввод кода
        case 'step3':
          //
          break;
      }

      this.step = event.step;

      this.uid = event.uid;
      this.until = event.until;
    },
  },
};
</script>
